$( document ).on("turbo:load", function(){

    if ($('.edit_node, .new_node').length > 0) {
        $('#node_map_id').on('change', function() {
            var map = $("#node_map_id option:selected").parent().attr('id');
            $('#node_map_type').val(map)
        });
    }

    if ($('.edit_content, .new_content').length > 0) {
        $('#content_map_id').on('change', function() {
            var map = $("#content_map_id option:selected").parent().attr('id');
            $('#content_map_type').val(map)
        });
    }
});
